const getApiUrl = () => {
  return `${window.location.origin}/api`;
};

export default getApiUrl;
